import axios from 'axios';

const {
    FLEETIO_AUTH_TOKEN,
    FLEETIO_ACCOUNT_TOKEN
} = process.env;

const apiFleetio = axios.create({
    baseURL: "https://secure.fleetio.com",
    headers: { 
        Accept: 'application/json', 
        Authorization: FLEETIO_AUTH_TOKEN,
        'Account-Token': FLEETIO_ACCOUNT_TOKEN, 
        'X-Api-Version': '2025-05-05'
    }
})

export default apiFleetio; 
